import React from 'react';
import styles from './Tab.module.scss';
import { Button } from 'components';
import { Icon } from 'components/common';
import { TabProps } from './types';

const Tab = (props: TabProps) => {
  const {
    text = 'tab',
    label = { type: '', value: '', title: '' },
    selected = false,
    onClick = () => console.log('TAB CLICKED!'),
    vertical = false
  } = props;

  return (
    <div
      className={styles.container}
      style={selected ? { color: styles.blackClicked } : {}}
      title={label.title || ''}
    >
      <Button onClick={onClick}>
        {
          {
            text: label.value,
            icon: <Icon icon={label.value} />
          }[label.type] || text
        }
      </Button>
      {selected &&
        <div
          className={vertical
            ? styles.selectedIndicatorVertical
            : styles.selectedIndicator}
        />
      }
    </div>
  );
};

const arePropsEqual = (prevProps, nextProps) => {
  if (prevProps.selected !== nextProps.selected) return false;
  return true;
};

export default React.memo(Tab, arePropsEqual);
